import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../App';

// Marketing module is accessible to super_admin and manager roles only
export function MarketingRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#0A0A0A' }}>
        <div className="text-center">
          <div className="w-8 h-8 border-2 border-[#D4A843] border-t-transparent rounded-full animate-spin mx-auto mb-3" />
          <p className="text-[#B9B9B9] text-sm">Loading...</p>
        </div>
      </div>
    );
  }

  // Check if user has required role
  const allowedRoles = ['super_admin', 'manager', 'marketing', 'special_ops'];
  if (!user || !allowedRoles.includes(user.role)) {
    return <Navigate to="/admin/dashboard" state={{ from: location }} replace />;
  }

  return children;
}
